import { render, staticRenderFns } from "./AllotAuthority.vue?vue&type=template&id=09f3cb6e"
import script from "./AllotAuthority.vue?vue&type=script&lang=js"
export * from "./AllotAuthority.vue?vue&type=script&lang=js"
import style0 from "./AllotAuthority.vue?vue&type=style&index=0&id=09f3cb6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports